module.exports = __webpack_public_path__ + "media/a1.a0b8be3a.wav";